'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffLineItem', function ($state, TimeService, UserPermissionsService) {
      return {
        templateUrl: 'views/directives/saDaysOffLineItem.html',
        restrict: 'A',
        scope: {
          dayoff:'=saDaysOffLineItem',
          me:'=loggedInUser',
          user: '=',
          layout: '@',
          link: '@'
        },
        link: function(scope, elem, attrs) {
          UserPermissionsService.can('availability_sets.view_reasons', scope.dayoff.organization_id)
            .then(function(val) {
              scope.canViewComment = val;
            });

          scope.dayOffUser = !_.isUndefined(scope.user) ? scope.user : scope.dayoff.user;

          if (scope.layout === 'status') {
            scope.withStatus = true;
          } else {
            scope.withStatus = false;
          }

          if (scope.link === 'true') {
            scope.callLink = function() {
              $state.go('profile.daysOff.show', {userId: scope.dayoff.user_id, dayOffId: scope.dayoff.id});
            };
          }

          scope.dayoffMif = TimeService.minimalIntervalTimeFormat(scope.dayoff.range_twix);
          scope.dayoffDayCounts = scope.dayoff.$getNumberOfFullAndPartialDays();
        }
      };
    });
